import React, { useState, SyntheticEvent } from "react";

function useDotsSelector() {
  const [anchor, setAnchor] = useState<any>(null);
  const open = Boolean(anchor);

  const handleClick = (event: SyntheticEvent) => setAnchor(event.currentTarget);

  const handleClose = () => setAnchor(null);

  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));

  return {
    role,
    handleClose,
    handleClick,
    open,
    anchor,
  };
}

export default useDotsSelector;
